module.exports = __webpack_public_path__ + "img/1-main.4594a0fd.jpg";